import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { useEditorProps } from './context/EditorPropsContext';

/** Keeps Lexical's editable flag in step with the `disabled` prop (the composer config only sets it at mount). */
export const EditorDisabledPlugin = () => {
  const { disabled } = useEditorProps();
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(!disabled);
  }, [disabled, editor]);

  return null;
};
